import { supabase } from '@/lib/supabase/client'
import { TablesUpdate } from '@/lib/supabase/types'

export type Settings = {
  feeds: string[]
  emails: string[]
  send_time: string
  prioritized_topics: string[]
}

export const getSettings = async (): Promise<Settings | null> => {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  if (!user) throw new Error('User not authenticated')

  const { data, error } = await supabase
    .from('rss_settings')
    .select('feeds, emails, send_time, prioritized_topics')
    .eq('user_id', user.id)
    .single()

  if (error && error.code !== 'PGRST116') {
    // PGRST116: no rows found
    console.error('Error fetching settings:', error)
    throw error
  }

  return data
    ? {
        feeds: data.feeds || [],
        emails: data.emails || [],
        send_time: data.send_time || '08:00',
        prioritized_topics: data.prioritized_topics || [],
      }
    : null
}

export const updateSettings = async (settings: Settings): Promise<void> => {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  if (!user) throw new Error('User not authenticated')

  const updateData: TablesUpdate<'rss_settings'> = {
    ...settings,
    user_id: user.id,
    updated_at: new Date().toISOString(),
  }

  const { error } = await supabase
    .from('rss_settings')
    .upsert(updateData, { onConflict: 'user_id' })

  if (error) {
    console.error('Error updating settings:', error)
    throw error
  }
}
